export const typesFiles = {
    productFile: "Archivos adjuntos para productos",
    blogFile: "Archivos adjuntos para páginas personalizadas"
};
